import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {addLogo} from 'storyboard/actions/add-logo-actions';
import {deleteLogo} from 'storyboard/actions/delete-logo-actions';
import StoryboardLogoModal from 'storyboard/components/storyboard-logo-modal';

class StoryboardLogoModalContainer extends React.Component {
  static propTypes = {
    closeModal: PropTypes.func,
    data: PropTypes.object.isRequired,
    dispatch: PropTypes.func,
    isOpen: PropTypes.bool,
    title: PropTypes.string,
    type: PropTypes.string,
  };

  static defaultProps = {
    closeModal: () => {},
    dispatch: () => {},
    isOpen: false,
    title: '',
    type: '',
  };

  constructor() {
    super();
    this.addLogo = this.addLogo.bind(this);
    this.deleteLogo = this.deleteLogo.bind(this);
  }

  addLogo(logo) {
    this.props.dispatch(addLogo(logo));
  }

  deleteLogo(logo) {
    this.props.dispatch(deleteLogo(logo));
  }

  render() {
    return (
      <StoryboardLogoModal
        addLogo={this.addLogo}
        closeModal={this.props.closeModal}
        data={this.props.data}
        deleteLogo={this.deleteLogo}
        isOpen={this.props.isOpen}
        title={this.props.title}
        type={this.props.type}
      />
    );
  }
}

export default connect()(StoryboardLogoModalContainer);
